import React, { useState } from 'react';
import { CreditCard, Wallet, Truck, CheckCircle } from 'lucide-react';

interface CheckoutProps {
  onSuccess: () => void;
  onBack: () => void;
  total: number;
}

export const Checkout: React.FC<CheckoutProps> = ({ onSuccess, onBack, total }) => {
  const [step, setStep] = useState<'shipping' | 'payment'>('shipping');
  const [loading, setLoading] = useState(false);

  const handlePay = () => {
    setLoading(true);
    setTimeout(() => {
        setLoading(false);
        onSuccess();
    }, 2000);
  };

  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl min-h-[80vh]">
        <button onClick={onBack} className="text-gray-500 text-sm font-bold uppercase mb-8">
             &larr; Volver al carrito
        </button>

        <div className="flex items-center gap-4 mb-8">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${step === 'shipping' ? 'bg-[#FF7F32] text-white' : 'bg-[#061970] text-white'}`}>1</div>
            <div className="h-1 flex-1 bg-gray-200">
                <div className={`h-full bg-[#061970] transition-all duration-500 ${step === 'payment' ? 'w-full' : 'w-0'}`} />
            </div>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${step === 'payment' ? 'bg-[#FF7F32] text-white' : 'bg-gray-200 text-gray-500'}`}>2</div>
        </div>

        {step === 'shipping' ? (
            <div className="bg-white p-6 rounded-2xl shadow-lg animate-in slide-in-from-right duration-300 fade-in">
                <h2 className="text-2xl font-black italic text-[#061970] mb-6 uppercase">Envío</h2>
                <div className="grid gap-4">
                    <input type="text" placeholder="Nombre Completo" className="w-full p-4 bg-gray-50 rounded-lg border-2 border-transparent focus:border-[#459EDF] outline-none font-bold text-[#061970]" />
                    <input type="text" placeholder="Dirección" className="w-full p-4 bg-gray-50 rounded-lg border-2 border-transparent focus:border-[#459EDF] outline-none font-bold text-[#061970]" />
                    <div className="grid grid-cols-2 gap-4">
                        <input type="text" placeholder="Ciudad" className="w-full p-4 bg-gray-50 rounded-lg border-2 border-transparent focus:border-[#459EDF] outline-none font-bold text-[#061970]" />
                        <input type="text" placeholder="CP" className="w-full p-4 bg-gray-50 rounded-lg border-2 border-transparent focus:border-[#459EDF] outline-none font-bold text-[#061970]" />
                    </div>
                </div>
                <button 
                    onClick={() => setStep('payment')}
                    className="w-full mt-8 py-4 bg-[#061970] text-white font-black italic uppercase rounded-lg shadow-lg hover:bg-[#459EDF] transition-colors"
                >
                    Continuar a Pago
                </button>
            </div>
        ) : (
            <div className="bg-white p-6 rounded-2xl shadow-lg animate-in slide-in-from-right duration-300 fade-in">
                <h2 className="text-2xl font-black italic text-[#061970] mb-6 uppercase">Pago Seguro</h2>
                
                <div className="grid grid-cols-2 gap-4 mb-8">
                    <button className="p-4 border-2 border-[#459EDF] bg-[#459EDF]/5 rounded-xl flex flex-col items-center gap-2 text-[#061970]">
                        <CreditCard className="w-6 h-6" />
                        <span className="font-bold text-xs uppercase">Tarjeta</span>
                    </button>
                    <button className="p-4 border-2 border-gray-100 rounded-xl flex flex-col items-center gap-2 text-gray-400 hover:border-gray-300">
                        <Wallet className="w-6 h-6" />
                        <span className="font-bold text-xs uppercase">Digital</span>
                    </button>
                </div>

                <div className="space-y-4 mb-8">
                    <div className="p-4 bg-gray-50 rounded-lg flex items-center gap-4 border border-gray-200">
                         <div className="w-10 h-6 bg-gray-300 rounded" />
                         <input type="text" placeholder="0000 0000 0000 0000" className="bg-transparent w-full outline-none font-mono text-[#061970]" />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <input type="text" placeholder="MM/YY" className="p-4 bg-gray-50 rounded-lg outline-none font-mono text-[#061970]" />
                        <input type="text" placeholder="CVC" className="p-4 bg-gray-50 rounded-lg outline-none font-mono text-[#061970]" />
                    </div>
                </div>

                <div className="flex justify-between items-center mb-6 text-sm font-bold text-gray-500">
                    <span>Total a pagar</span>
                    <span className="text-2xl text-[#061970]">${total.toLocaleString()}</span>
                </div>

                <button 
                    onClick={handlePay}
                    disabled={loading}
                    className="w-full py-4 bg-[#FF7F32] text-white font-black italic uppercase rounded-lg shadow-lg hover:bg-[#ff6b1a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                    {loading ? (
                        <span className="animate-pulse">Procesando...</span>
                    ) : (
                        <>
                            Confirmar Pedido <CheckCircle className="w-5 h-5" />
                        </>
                    )}
                </button>
            </div>
        )}
    </div>
  );
};
